import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.button`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.buttons.primary.backgroundColor};
  color: ${({ theme }) => theme.buttons.primary.color};
  height: 50px;
  border: none;
  width: 250px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 0.9)};
  border-radius: ${({ theme }) => theme.old ? 'none' : '30px'};

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 500 : 400};
  font-size: ${({ theme }) => theme.old ? '16px' : '18px'};
  line-height: 23px;
  /* identical to box height, or 144% */

  letter-spacing: 0.04em;

  color: #ffffff;

  &:hover {
    transition: all 0.3s;
    opacity: 0.8;
    background:  ${({ theme }) => theme.old ? '#191919' : theme.buttons.primary.backgroundColor};
  }
  &:focus {
    outline: 0;
  }
  @media (max-width: 992px) {
    width: 100%;
  }
`;

function FinishCustomizingButton({ slug }) {
  const history = useHistory();
  return (
    <Wrapper
      className="finish-customizing"
      onClick={() => {
        history.push('/products/' + slug);
      }}
    >
      Finish Customizing
    </Wrapper>
  );
}

export default FinishCustomizingButton;
